import { API, message } from '../../api'
import { FAMOUS_PEDIA_DATA_MANAGER, COMMENT_DATA_MANAGER, RECORD_DATA_MANAGER } from '../../data';
import * as types from '../mutation-types';
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../data/base/consts';
import { CONFIG } from '../../config';
import { UTILS } from '../../utils';

export default {
    namespaced: true,
    state: {
        curPediaMenuId: 2,
        curPediaListGot: false,
        curPediaListData: [],
        curPediaTotalData: {},
        curPediaPageArr: [],
        searchPediaText: '',
        searchPediaListData: [],
        totalUserInfoData: {},
        gotHotList: false,
        hotPediaTotalData: {},
        hotPediaList: [],
        hotPediaListObject: {},
        gotNewList: false,
        newPediaTotalData: {},
        newPediaList: [],
        newPediaListObject: {},
        gotMyList: false,
        myPeidaTotalData: {},
        myPediaList: [],
        myPediaOriginalList: {},
        gotGlanceList: false,
        glancePediaTotalData: {},
        glancePediaList: [],
        gotCollectList: false,
        collectPediaTotalData: 1,
        collectPediaList: [],
        curPediaCreateTabIndex: 0,
        gotCurrentPediaData: false,
        allPediaOriginalList: {},
        totalPediaOriginalList: {},
        curPediaEditType: '',
        curPediaBaziId: null,
        curPediaBaziInfo: {},
        curPediaBaziInfoToBZ: {},
        curPediaBaziCollect: false,
        curPediaBaziLike: false,
        curPediaBaziEditInfo: {},
        curPediaBaziEditHistoryList: [],
        curPediaBaziBaseData: {},
        curPediaBaziShowSavePop: false,
        curPediaBaziCanSaveList: [],
        curPediaBaziShowGroupPop: false,
        curPediaBaziNewFormData: {},
        curPediaPipanInfo: {},
        curPediaPipanInfoChanged: false,
        curPediaPipanMyData: {},
        curPediaPipanModifyRemark: '',
        curPediaDayunLiunianList: [],
        curPediaContentTab: 1,
    },
    getters: {},
    mutations: {
        [types.FAMOUS_PEDIA_UPDATE_HOT_LIST_DATA](state, data) {
            state.hotPediaTotalData = Object.assign(data.total, {});
            state.curPediaTotalData = state.hotPediaTotalData;
            var resultData = FAMOUS_PEDIA_DATA_MANAGER.getFamousPediaListByList(data.info);
            // state.hotPediaList = state.hotPediaList.concat(resultData.resultList);
            state.hotPediaList = [].concat(resultData.resultList);
            state.hotPediaListObject[data.total.nowpage] = state.hotPediaList;
            state.allPediaOriginalList = Object.assign(resultData.resultData, state.allPediaOriginalList);
            state.curPediaListData = [].concat(state.hotPediaList);
        },
        [types.FAMOUS_PEDIA_UPDATE_NEW_LIST_DATA](state, data) {
            state.newPediaTotalData = Object.assign(data.total, {});
            state.curPediaTotalData = state.newPediaTotalData;
            if(data.userinfo) {
                state.totalUserInfoData = Object.assign(data.userinfo, state.totalUserInfoData)
            }
            var resultData = FAMOUS_PEDIA_DATA_MANAGER.getFamousPediaNewListByList(data.info, state.totalUserInfoData);
            // state.newPediaList = state.newPediaList.concat(resultData.resultList);
            state.newPediaList = [].concat(resultData.resultList);
            state.newPediaListObject[data.total.nowpage] = state.newPediaList;
            state.allPediaOriginalList = Object.assign(resultData.resultData, state.allPediaOriginalList);
            state.curPediaListData = [].concat(state.newPediaList);
        },
        [types.FAMOUS_PEDIA_UPDATE_COLLECT_LIST_DATA](state, data) {
            state.collectPediaTotalData = Object.assign(data.total, {});
            state.curPediaTotalData = state.collectPediaTotalData;
            if(data.userinfo) {
                state.totalUserInfoData = Object.assign(data.userinfo, state.totalUserInfoData)
            }
            var resultData = FAMOUS_PEDIA_DATA_MANAGER.getFamousPediaListByListType(data.info, state.totalUserInfoData, 'collect');
            state.collectPediaList = state.collectPediaList.concat(resultData.resultList);
            state.totalPediaOriginalList = Object.assign(resultData.resultData, state.totalPediaOriginalList);
            state.curPediaListData = [].concat(state.collectPediaList);
        },
        [types.FAMOUS_PEDIA_UPDATE_MY_LIST_DATA](state, data) {
            state.myPeidaTotalData = Object.assign(data.total, {});
            state.curPediaTotalData = state.myPeidaTotalData;
            if(data.userinfo) {
                state.totalUserInfoData = Object.assign(data.userinfo, state.totalUserInfoData)
            }
            var resultData = FAMOUS_PEDIA_DATA_MANAGER.getFamousPediaListByListType(data.info, state.totalUserInfoData, 'my');
            state.myPediaList = state.myPediaList.concat(resultData.resultList);
            state.myPediaOriginalList = Object.assign(resultData.resultData, state.myPediaOriginalList);
            state.curPediaListData = [].concat(state.myPediaList);
        },
        [types.FAMOUS_PEDIA_UPDATE_GLANCE_LIST_DATA](state, data) {
            state.glancePediaTotalData = Object.assign(data.total, {});
            state.curPediaTotalData = state.glancePediaTotalData;
            if(data.userinfo) {
                state.totalUserInfoData = Object.assign(data.userinfo, state.totalUserInfoData)
            }
            var resultData = FAMOUS_PEDIA_DATA_MANAGER.getFamousPediaListByListType(data.info, state.totalUserInfoData, 'glance');
            state.glancePediaList = state.glancePediaList.concat(resultData.resultList);
            state.totalPediaOriginalList = Object.assign(resultData.resultData, state.totalPediaOriginalList);
            state.curPediaListData = [].concat(state.glancePediaList);
        },
    },
    actions: {
        initHotList({ state, commit }, params) {
            if(state.gotHotList) {
                state.curPediaListGot = true;
                state.curPediaListData = state.hotPediaList;
                state.curPediaTotalData = state.hotPediaTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getHotList({
                page: 1
            }, function(data) {
                console.log('获取热门名人列表成功:::::::', data)
                state.gotHotList = true;
                state.curPediaListGot = state.gotHotList;
                state.hotPediaList.splice(0);
                commit(types.FAMOUS_PEDIA_UPDATE_HOT_LIST_DATA, data);
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            });
        },
        updateHotList({state, commit}, params) {
            var nowpage = parseInt(state.curPediaTotalData.nowpage),
                totalpage = state.curPediaTotalData.totalpage;
            var tempArr = state.hotPediaListObject[nowpage];
            if(tempArr && tempArr.length > 0) {
                state.curPediaListData = [].concat(tempArr);
                state.curPediaTotalData = state.hotPediaTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            if(nowpage <= totalpage) {
                API.getHotList({
                    page: nowpage
                }, function(data) {
                    console.log('更新热门名人列表成功:::::::', data)
                    commit(types.FAMOUS_PEDIA_UPDATE_HOT_LIST_DATA, data)
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                })
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }
        },
        // 更新评论数:累加1
        updateHotListCommentNum({ state }) {
            for(var i = 0; i < state.hotPediaList.length; i++) {
                if(state.hotPediaList[i].id == state.curPediaBaziId) {
                    state.hotPediaList[i].replyNum++;
                    state.curPediaBaziInfo.reply = state.hotPediaList[i].replyNum;
                }
            }
        },
        initNewList({ state, commit }, params) {
            if(state.gotNewList) {
                state.curPediaListGot = true;
                state.curPediaListData = state.newPediaList;
                state.curPediaTotalData = state.newPediaTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getNewList({
                page: 1
            }, function(data) {
                console.log('获取最新创建列表成功:::::::', data)
                state.gotNewList = true;
                state.curPediaListGot = state.gotNewList;
                state.newPediaList.splice(0);
                commit(types.FAMOUS_PEDIA_UPDATE_NEW_LIST_DATA, data);
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            });
        },
        updateNewList({ state, commit }, params) {
            var nowpage = parseInt(state.curPediaTotalData.nowpage),
                totalpage = state.curPediaTotalData.totalpage;
            var tempArr = state.newPediaListObject[nowpage];
            if(tempArr && tempArr.length > 0) {
                state.curPediaListData = [].concat(tempArr);
                state.curPediaTotalData = state.newPediaTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            if(nowpage <= totalpage) {
                API.getNewList({
                    page: nowpage
                }, function(data) {
                    console.log('更新最新创建列表成功:::::::', data)
                    commit(types.FAMOUS_PEDIA_UPDATE_NEW_LIST_DATA, data)
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                })
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }

        },
        initMyList({ state, commit }, params) {
            if(state.gotMyList) {
                state.curPediaListGot = state.gotMyList;
                state.curPediaListData = state.myPediaList;
                state.curPediaTotalData = state.myPeidaTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getMyList({
                page: 1
            }, function(data) {
                console.log('获取我的百科列表成功:::::::', data)
                state.gotMyList = true;
                state.curPediaListGot = state.gotMyList;
                state.myPediaList.splice(0);
                commit(types.FAMOUS_PEDIA_UPDATE_MY_LIST_DATA, data)
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        updateMyList({ state, commit }, params) {
            var nowpage = parseInt(state.myPeidaTotalData.nowpage),
                totalpage = state.myPeidaTotalData.totalpage;
            if(nowpage < totalpage) {
                API.getMyList({
                    page: nowpage+1
                }, function(data) {
                    console.log('更新我的百科列表成功:::::::', data)
                    commit(types.FAMOUS_PEDIA_UPDATE_MY_LIST_DATA, data)
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                })
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }
        },
        initGlanceList({ state, commit }, params) {
            // if(state.gotGlanceList) {
            //     state.curPediaListGot = state.gotGlanceList;
            //     state.curPediaListData = state.glancePediaList;
            //     state.curPediaTotalData = state.glancePediaTotalData;
            //     if(params && params.cb && typeof(params.cb) == 'function') {
            //         params.cb();
            //     }
            //     return;
            // }
            API.getGlanceList({
                page: 1
            }, function(data) {
                console.log('获取最近浏览百科列表成功:::::::', data)
                state.gotGlanceList = true;
                state.curPediaListGot = state.gotGlanceList;
                state.glancePediaList.splice(0);
                commit(types.FAMOUS_PEDIA_UPDATE_GLANCE_LIST_DATA, data);
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        updateGlanceList({ state, commit }, params) {
            var nowpage = parseInt(state.glancePediaTotalData.nowpage),
                totalpage = state.glancePediaTotalData.totalpage;
            if(nowpage < totalpage) {
                API.getGlanceList({
                    page: nowpage+1
                }, function(data) {
                    console.log('更新最近浏览百科列表成功:::::::', data)
                    commit(types.FAMOUS_PEDIA_UPDATE_GLANCE_LIST_DATA, data)
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                })
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }
        },
        initCollectList({ state, commit }, params) {
            if(state.gotCollectList) {
                state.curPediaListGot = state.gotCollectList;
                state.curPediaListData = state.collectPediaList;
                state.curPediaTotalData = state.collectPediaTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getCollectList({
                page: 1
            }, function(data) {
                console.log('获取我收藏的百科列表成功:::::::', data)
                state.gotCollectList = true;
                state.curPediaListGot = state.gotCollectList;
                state.collectPediaList.splice(0);
                commit(types.FAMOUS_PEDIA_UPDATE_COLLECT_LIST_DATA, data);
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        updateCollectList({ state, commit }, params) {
            var nowpage = parseInt(state.collectPediaTotalData.nowpage),
                totalpage = state.collectPediaTotalData.totalpage;
            if(nowpage < totalpage) {
                API.getCollectList({
                    page: nowpage+1
                }, function(data) {
                    console.log('更新我收藏的百科列表成功:::::::', data)
                    commit(types.FAMOUS_PEDIA_UPDATE_COLLECT_LIST_DATA, data)
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                })
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }
        },
        initCurPediaList({ dispatch, state }, params) {
            state.curPediaMenuId = params.curId;
            state.curPediaListGot = false;
            state.curPediaListData = [];
            state.curPediaPageArr = [];
            switch(params.curId) {
                case 1:
                    dispatch('initHotList', params);
                    break;
                case 2:
                    dispatch('initNewList', params);
                    break;
                case 3:
                    dispatch('initCollectList', params);
                    break;
                case 4:
                    dispatch('initMyList', params);
                    break;
                case 5:
                    dispatch('initGlanceList', params);
                    break;
                default:
                    break;
            }
        },
        initCurPediaPage({state}) {
            console.log('initCurPediaPage-------', state.curPediaTotalData)
            var nowP = parseInt(state.curPediaTotalData.nowpage),
                totalP = parseInt(state.curPediaTotalData.totalpage);
            state.curPediaPageArr = UTILS.makePage(totalP, nowP, 1);
        },
        initBaikeInfo({ dispatch, state }, params) {
            API.getBaiKeInfo({
                id: params.baikeId
            }, function(data) {
                state.curPediaBaziId = data.baike.id;
                state.curPediaBaziInfo = data.baike;
                state.curPediaBaziInfoToBZ = data.toBz;
                state.curPediaBaziCollect = data.isCollect == 1 ? true : false;
                state.curPediaBaziLike = data.isLikeBaike == 1 ? true : false;
                state.curPediaBaziEditInfo = FAMOUS_PEDIA_DATA_MANAGER.getBaiKeEditInfoByData(data);
                console.log('获取百科八字信息成功::::::::', data.isCollect, data, data.baike.f_status, state.curPediaBaziInfoToBZ, data.isCollect, state.curPediaBaziCollect);
                
                //f_status状态码::: 1未通过>2待审核>3待提交>4已编辑>5我创建>6我论过
                var status = params.baikeStatus;
                if(params.baikeType == 'my') {
                    if(status == 1) {
                        state.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.modify; 
                    }else if(status == 2) {
                        state.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.check; 
                    }else if(status == 3) {
                        state.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.edit;
                    }else {
                        state.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.read;
                    }
                    // 设置我的百科的状态数据
                    state.curPediaBaziBaseData = {};
                    state.curPediaBaziBaseData['id'] = params.baikeId;
                    state.curPediaBaziBaseData['f_status'] = params.baikeStatus;
                }else {
                    state.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.read;
                }
                
                dispatch('initBaikePiPanInfo', {
                    data: data.baike,
                    baikeType: params.baikeType,
                    fromDetail: params.fromDetail,
                    sucCb: params.sucCb,
                    failCb: params.failCb
                });
                
            }, function() {
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
            })
        },
        initBaikePiPanInfo({ dispatch, state }, params) {
            // 暂存命盘数据
            if(!params.fromDetail) {
                AppFate.$store.state.detail.personInfo = params.data;
            }
            dispatch('minifatefortune/initCommentMiniFateFortune', params.data, {root: true});
            
            API.getBaiKePiPanInfo({
                id: params.data.id
            }, function(data){
                state.gotCurrentPediaData = true;
                state.curPediaPipanInfo = data.my && data.my.content && params.baikeType == 'my' ? data.my.content : data.info;
                state.curPediaPipanMyData = data.my;
                console.log('获取百科批盘信息成功::::::::', data, data.my, state.curPediaPipanInfo);

                // 初始化批盘页:大运流年数据列表
                dispatch('famouspediacomment/initCommentList', state.curPediaBaziId, {root: true});
                var fortuneList = AppFate.$store.state.minifatefortune.fortuneListData,
                    beforeList = AppFate.$store.state.minifatefortune.fortuneBeforeListData;
                state.curPediaDayunLiunianList = COMMENT_DATA_MANAGER.getDayunLiunianListByList(beforeList, fortuneList, [], state.curPediaPipanInfo.big);

                // 初始化数据完成之后执行UI回调函数
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    setTimeout(() => {
                        params.sucCb(state.curPediaEditType);
                    }, 100);
                }
                // 上报浏览
                if(state.curPediaEditType == 'read') {
                    dispatch('updateGlanceBaike', params.data.id);
                }
            })
        },
        updateCurPediaEditType({ state }, params) {
            if(!state.curPediaBaziInfo) {
                return;
            }
            var status = state.curPediaBaziInfo.f_status;
            if(status == 3) {
                state.curPediaEditType = 'edit';
            }else {
                state.curPediaEditType = 'modify';
            }
            
            // 执行回调函数
            if(params && params.cb && typeof(params.cb) == 'function') {
                params.cb();
            }
        },
        getBaikeLog({ state }, params) {
            console.log('getBaikeLog-------', state.curPediaBaziId);
            if(!state.curPediaBaziId) { return; }
            API.getBaikeLog({
                id: state.curPediaBaziId
            }, function(data) {
                console.log('获取八字编辑历史列表成功:::::::', data)
                state.curPediaBaziEditHistoryList = FAMOUS_PEDIA_DATA_MANAGER.getBaiKeEditHistoryListByData(data);
            })
        },
        getBaikeSearchResult({ state }, params) {
            console.log('getBaikeSearchResult-------', params)
            state.searchPediaText = params.text;
            API.getSearchResult({
                name: params.text
            }, function(data) {
                console.log('线上搜索百科成功返回:::::::', data)
                var resultData = FAMOUS_PEDIA_DATA_MANAGER.getFamousPediaListByList(data);
                state.searchPediaListData = resultData.resultList;
                if(data.length > 0) {
                    state.searchPediaText = '';
                }
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(data);
                }
            })
        },
        addBaziBaike({ dispatch, state }, params) {
            console.log('addBaziBaike-------', params)
            API.addPaiPan(params.formData, function(data) {
                console.log('百科添加八字成功:::::::', data)
                dispatch('addBaike', {
                    data: data,
                    cb: params.cb
                });
                // 更新列表数据
                dispatch('record/updateRecordListData', data, {root: true});
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                dispatch('group/updateGroupListData', recordData, {root: true});
                // 处理过滤列表数据
                dispatch('record/updateRecordFilterList', null, {root: true});
            })
        },
        addBaike({ dispatch, state }, params) {
            console.log('addBaiKe--------', params);
            var baikeParams = FAMOUS_PEDIA_DATA_MANAGER.getBaiKeParamsByData(params.data);
            API.addBaiKe(baikeParams, function(data) {
                console.log('添加百科成功::::::', data)
                state.curPediaMenuId = 4;
                state.curPediaBaziId = data.info.id;
                state.curPediaBaziInfo = data.info;
                state.curPediaBaziBaseData = {};
                state.curPediaBaziBaseData['id'] = data.info.id;
                state.curPediaBaziBaseData['f_status'] = 3;
                state.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.edit;
                
                // 新增列表数据
                var userData = AppFate.$store.state.userData,
                creator = userData && userData.info ? userData.info.nickname : '匿名';
                var newData = FAMOUS_PEDIA_DATA_MANAGER.getFamousPediaMyListByAddedData(data.info, creator);
                state.myPediaList.splice(0, 0, newData);
                state.myPediaOriginalList[newData.id] = {'baike': {}, 'base': {}};
                state.myPediaOriginalList[newData.id]['baike'] = data.info;
                state.myPediaOriginalList[newData.id]['base']['f_status'] = newData['status'];
                console.log('添加百科列表数据:::::::', newData, state.myPediaList, state.myPediaOriginalList)
                // 暂存命盘数据
                AppFate.$store.state.detail.personInfo = data.info;
                dispatch('minifatefortune/initCommentMiniFateFortune', data.info, {root: true});
                API.getBaiKePiPanInfo({
                    id: data.info.id
                }, function(data){
                    console.log('获取百科批盘信息成功::::::::', data);
                    state.gotCurrentPediaData = true;
                    state.curPediaPipanInfo = data.info;
                    state.curPediaPipanMyData = data.my;
                    // 初始化评论数据
                    dispatch('famouspediacomment/initCommentList', state.curPediaBaziId, {root: true});
                    // 初始化批盘页:大运流年数据列表
                    var fortuneList = AppFate.$store.state.minifatefortune.fortuneListData,
                        beforeList = AppFate.$store.state.minifatefortune.fortuneBeforeListData;
                    state.curPediaDayunLiunianList = COMMENT_DATA_MANAGER.getDayunLiunianListByList(beforeList, fortuneList, [], data.info.big);
                    // 初始化数据完成之后执行UI回调函数
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                })
            })
        },
        updateBaikePipan({ dispatch, state }, params) {
            console.log('updateBaikePipan-----------', params, state.curPediaBaziInfo.id)
            var newParams = {};
            if(params.type && (params.type == 'dayun' || params.type == 'liunian')) {
                var dayunLiunianList = [].concat(state.curPediaDayunLiunianList);
                var resultData = COMMENT_DATA_MANAGER.getBigParamsByParams(dayunLiunianList, state.curPediaPipanInfo.big, params);
                newParams = {
                    id: state.curPediaBaziInfo.id,
                    info: resultData.infoData
                };
            }
            if(params.info) {
                newParams = {
                    id: state.curPediaBaziInfo.id,
                    info: JSON.stringify(params.info)
                }
            }
            API.updateBaiKePiPanInfo(newParams, function(data) {
                if(data.ret) {
                    console.log('更新成功:::::::', data)
                    state.curPediaPipanInfoChanged = true;
                    // 更新迷你运盘的数据编辑状态:大运列表数据+流年列表数据
                    if(params.type == 'dayun') {
                        dispatch('minifatefortune/updateFamousMiniFortuneList', {
                            pediaList: state.curPediaDayunLiunianList
                        }, {root: true})
                    }
                    if(params.type == 'liunian') {
                        dispatch('minifatefortune/updateFamousMiniLiunianList', {
                            pediaList: state.curPediaDayunLiunianList,
                            parentData: params.parentData
                        }, {root: true});
                    }
                    // 更新名人简介
                    var infoData = params.info;
                    if(infoData && (infoData['base'] || infoData['base'] == '')) {
                        state.curPediaPipanInfo.base = infoData['base'];
                    }
                    // 更新当前数据的status状态4561->3
                    state.myPediaList = FAMOUS_PEDIA_DATA_MANAGER.updatePediaListDataByKeyValue(state.myPediaList, state.curPediaBaziId, 'status', 3)
                    if(state.myPediaOriginalList[state.curPediaBaziId]) {
                        state.myPediaOriginalList[state.curPediaBaziId]['base']['f_status'] = 3;
                    }
                    state.curPediaListData = state.myPediaList;

                    setTimeout(() => {
                        // 执行回调函数:更新UI层交互
                        if(params.cb && typeof(params.cb) == 'function') {
                            params.cb();
                        }
                    }, 100);
                }
                // 审核过后再次修改的，会变动id，增加修改历史
                if(data.sid) {
                    state.curPediaPipanMyData = state.curPediaPipanMyData ? state.curPediaPipanMyData : {};
                    state.curPediaPipanMyData.id = data.sid;
                }
            }, function(data) {
                if(data.status_code && params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb('更新失败，' + message[data.status_code]);
                }
                setTimeout(() => {
                    // 执行回调函数:更新UI层交互
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }, 100);
            });
        },
        submitBaiKeCheck({ dispatch, state }, params) {
            console.log('submitBaiKeCheck----', state.curPediaBaziInfo, state.curPediaPipanMyData, state.curPediaEditType)
            // 更新成功后更新当前数据为我的数据id
            if(state.curPediaPipanMyData && state.curPediaPipanMyData.bid == state.curPediaBaziInfo.id) {
                state.curPediaBaziInfo.id = state.curPediaPipanMyData.id;
            }

            API.submitBaiKeCheck({
                id: state.curPediaBaziInfo.id
            }, function(data) {
                if(data.ret) {
                    console.log('提交百科审核成功:::::::', data)
                    // 更新当前数据的status状态3->2
                    state.myPediaList = FAMOUS_PEDIA_DATA_MANAGER.updatePediaListDataByKeyValue(state.myPediaList, state.curPediaBaziId, 'status', 2)
                    if(state.myPediaOriginalList[state.curPediaBaziId]) {
                        state.myPediaOriginalList[state.curPediaBaziId]['base']['f_status'] = 2;
                    }
                    state.curPediaListData = state.myPediaList;

                    if(params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                }
            }, function(data) {
                console.log('提交百科审核失败:::::::', data)
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb(data);
                }
            })
        },
        submitBaiKePipanCheck({ dispatch, state }, params) {
            console.log('submitBaiKePipanCheck-----', state.curPediaPipanMyData, state.curPediaEditType)
            API.submitBaiKePiPanCheck({
                id: state.curPediaPipanMyData.id,
                f_remark: state.curPediaPipanModifyRemark
            }, function(data) {
                if(data.ret) {
                    console.log('提交百科批盘审核成功:::::::', data, state.curPediaBaziId)
                    // 更新当前数据的status状态3->2
                    state.myPediaList = FAMOUS_PEDIA_DATA_MANAGER.updatePediaListDataByKeyValue(state.myPediaList, state.curPediaBaziId, 'status', 2)
                    if(state.myPediaOriginalList[state.curPediaBaziId]) {
                        state.myPediaOriginalList[state.curPediaBaziId]['base']['f_status'] = 2;
                    }
                    state.curPediaListData = state.myPediaList;
                    if(params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                }
            }, function(data) {
                console.log('提交百科批盘审核失败:::::::', data)
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb(data);
                }
            })
        },
        updateGlanceBaike({ state }, baziId) {
            var userData = AppFate.$store.state.userData;
            if(CONFIG.platform == 'web' && (!userData || !userData.token)) {
                return;
            }
            API.updateGlanceBaiKe({
                bid: baziId
            }, function(data) {
                if(data.ret) {
                    console.log('上报百科浏览成功:::::::', baziId)
                }
            });
        },
        toggleCollectBaike({ state }, params) {
            var baikeId = state.curPediaBaziId,
                collectStatus = state.curPediaBaziCollect;
            console.log('collectBaike-------', baikeId, collectStatus);
            if(collectStatus) {
                API.unCollectBaiKe({
                    bid: baikeId
                }, function(data) {
                    if(data.ret) {
                        state.gotCollectList = false;
                        state.curPediaBaziCollect = false;
                        if(params.sucUnCCb && typeof(params.sucUnCCb) == 'function') {
                            params.sucUnCCb();
                        }
                    }
                })
            }else {
                API.collectBaiKe({
                    bid: baikeId
                }, function(data) {
                    if(data.ret) {
                        state.gotCollectList = false;
                        state.curPediaBaziCollect = true;
                        if(params.sucCCb && typeof(params.sucCCb) == 'function') {
                            params.sucCCb();
                        }
                    }
                })
            }
        },
        toggleLikeBaike({ state }, params) {
            console.log('toggleLikeBaike-------', state.curPediaBaziId);
            API.addBaiKeLike({
                bid: state.curPediaBaziId
            }, function(data) {
                if(data.ret) {
                    state.curPediaBaziLike = true;
                    state.curPediaBaziInfo.f_like = state.curPediaBaziInfo.f_like + 1;
                    if(params.sucCCb && typeof(params.sucCCb) == 'function') {
                        params.sucCCb();
                    }
                }
            })
        },
        checkCurFamousBaziSaveList({ state }) {
            var list = [];
            if(state.curPediaBaziInfoToBZ) {
                list = list.concat(state.curPediaBaziInfoToBZ.share);
                list = list.concat(state.curPediaBaziInfoToBZ.like);
            }
            console.log('checkCurFamousBaziSaveList--------', list)
            if(list.length > 0) {
                // 有相同四柱的情况:选择已有的弹框
                state.curPediaBaziShowSavePop = true;
                state.curPediaBaziCanSaveList = list;
            }else {
                // 没有相同四柱的情况:保存新八字弹框
                state.curPediaBaziShowGroupPop = true;
                state.curPediaBaziNewFormData['f_name'] = state.curPediaBaziNewFormData['f_name'] ? state.curPediaBaziNewFormData['f_name'] : state.curPediaBaziInfo['f_name'];
            }
        },
        // 将八字关联到百科
        updateBaikeBaziRelate({ state }, params) {
            console.log('updateBaikeBaziRelate-----', params)
            API.updatePaiPan({
                id: params.baziId,
                baikeid: params.baikeId
            }, function(data) {
                console.log('将八字关联到百科成功:::::::', data)
                state.curPediaBaziInfoToBZ.canSave = 0;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        // 更新百科要保存八字的表单信息
        updateBaikeBaziFormData({ state }, data) {
            if(data['group_time']){
                if(state.curPediaBaziNewFormData.group) {
                    state.curPediaBaziNewFormData.group = data.f_name;
                    state.curPediaBaziNewFormData.groupId = data.id;
                }else{
                    state.curPediaBaziNewFormData = Object.assign({
                        group: data.f_name,
                        groupId: data.id
                    }, state.curPediaBaziNewFormData);
                }
            }
            console.log('updateBaikeBaziFormData--------', state.curPediaBaziNewFormData)
        },
        // 保存新的八字
        saveBaikeNewBazi({ dispatch, state }, params) {
            // 处理未填写的情况，用默认的来做
            state.curPediaBaziNewFormData['f_name'] = state.curPediaBaziNewFormData['f_name'] ? state.curPediaBaziNewFormData['f_name'] : state.curPediaBaziInfo['f_name'];
            state.curPediaBaziNewFormData['group'] = state.curPediaBaziNewFormData['group'] ? state.curPediaBaziNewFormData['group'] : '未分组';
            state.curPediaBaziNewFormData['f_group'] = state.curPediaBaziNewFormData['groupId'] ? state.curPediaBaziNewFormData['groupId'] : 0;

            var formData = Object.assign(state.curPediaBaziNewFormData, {});
                formData = _.omit(formData, ['group', 'groupId']);
                formData = _.assign(formData, {'birthday': state.curPediaBaziInfo.birthdayDate}, {'sex': state.curPediaBaziInfo.sex})
            console.log('saveBaikeNewBazi--------', state.curPediaBaziNewFormData, formData)

            API.addPaiPan(formData, function(data) {
                window._czc.push(["_trackEvent", "八字模块", "八字", "百科保存八字"]);
                state.curPediaBaziShowGroupPop = false;
                state.curPediaBaziNewFormData = {};
                state.curPediaBaziInfoToBZ.canSave = 0;
                // 执行UI回调
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                // 更新列表数据
                dispatch('record/updateRecordListData', data, {root: true});
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                dispatch('group/updateGroupListData', recordData, {root: true});
                dispatch('group/resetChooseGroupData', null, {root: true});
                // 处理过滤列表数据
                dispatch('record/updateRecordFilterList', null, {root: true});
            })
        },
        resetPediaData({ state }) {
            state.gotCurrentPediaData = false;
            state.curPediaEditType = '';
            state.curPediaBaziId = null;
            state.curPediaBaziInfo = {};
            state.curPediaBaziCollect = false;
            state.curPediaBaziEditInfo = {};
            state.curPediaBaziEditHistoryList = [];
            state.curPediaBaziBaseData = {};
            state.curPediaBaziShowSavePop = false;
            state.curPediaBaziCanSaveList = [];
            state.curPediaBaziShowGroupPop = false;
            state.curPediaBaziNewFormData = {};
            state.curPediaPipanInfo = {};
            state.curPediaPipanInfoChanged = false;
            state.curPediaPipanMyData = {};
            state.curPediaPipanModifyRemark = '';
            state.curPediaDayunLiunianList = [];
            state.curPediaContentTab = 1;
        },
        resetData({ state }) {
            state.curPediaMenuId = 1;
            state.curPediaListGot = false;
            state.curPediaListData = [];
            state.curPediaTotalData = {};
            state.curPediaPageArr = [];
            state.searchPediaText = '';
            state.searchPediaListData = [];
            state.gotHotList = false;
            state.hotPediaTotalData = {};
            state.hotPediaList = [];
            state.gotNewList = false;
            state.newPediaTotalData = {};
            state.newPediaList = [];
            state.gotMyList = false;
            state.myPeidaTotalData = {};
            state.myPediaList = [];
            state.myPediaOriginalList = {};
            state.gotGlanceList = false;
            state.glancePediaTotalData = {};
            state.glancePediaList = [];
            state.gotCollectList = false;
            state.collectPediaTotalData = {};
            state.collectPediaList = [];
            state.curPediaCreateTabIndex = 0;
            state.gotCurrentPediaData = false;
            state.allPediaOriginalList = {};
            state.totalPediaOriginalList = {};
            state.curPediaEditType = '';
            state.curPediaBaziId = null;
            state.curPediaBaziInfo = {};
            state.curPediaBaziInfoToBZ = {};
            state.curPediaBaziCollect = false;
            state.curPediaBaziLike = false;
            state.curPediaBaziEditInfo = {};
            state.curPediaBaziEditHistoryList = [];
            state.curPediaBaziBaseData = {};
            state.curPediaBaziShowSavePop = false;
            state.curPediaBaziCanSaveList = [];
            state.curPediaBaziShowGroupPop = false;
            state.curPediaBaziNewFormData = {};
            state.curPediaPipanInfo = {};
            state.curPediaPipanInfoChanged = false;
            state.curPediaPipanMyData = {};
            state.curPediaPipanModifyRemark = '';
            state.curPediaDayunLiunianList = [];
            state.curPediaContentTab = 1;
        }
    }
}